import logger from '../logger'
import extendedObservable from './base'
import api from '../api'
import { merge } from 'lodash-es'


// ////////////////////////
// Countries Observable //
// ////////////////////////

export function CountriesObservable() {
  extendedObservable(this, 'countriesModel', [])

  const successHandler = (json) => {
    logger('SUCCESS :: Communicated with Geo Country Service', 'info')()
    logger(json, 'debug')()

    this.model = merge(this.model, json)
    return this.model
  }

  const errorHandler = (xhr, status, errorThrown) => {
    logger(`ERROR :: (XHR) Failed to communicate with Country Service${errorThrown}`, 'error')()
    logger(`Status: ${status}`, 'error')()
    logger(xhr, 'error')()
  }

  Object.defineProperty(this.model, 'countryCodeToName', {
    value: (countryCode) => {
      logger('Country name from countryCode ', 'debug')()

      // If the item has a fulfillmentType of 'SHIP' then it is ship
      // if there is no shipMethod set and no address set, then it is ship
      return this.model.find(o => o.code === countryCode)
    },
    enumerable: true,
    configurable: false,
  })

  // register and unregister event listeners
  this.on('registerCountriesObserver', observer => this.registerObserver(observer))
  this.on('unregisterCountriesObserver', observer => this.unregisterObserver(observer))

  // Fetch all the countries and states and provinces from the REST service.
  this.on('fetchCountries', () => {
    logger('XHR :: Fetching countries from Geo Country Service...', 'info')()
    api.countries.get()
      .then(successHandler)
      .then(this.notifyObservers)
      .fail(errorHandler)
  })
}
